import axios from "fetch-api/fetch-api";

export const getAvailableDeliveryMethods = async (postalCode: string) => axios.get(`s/get-available-delivery-methods?postalCode=${postalCode}`);
